(ns frontend.view.grid.surveys-grid.mass-remind.model)

(def root-path [::state])

(def modal-open?-path [:modal-open?])
(def modal-open?-full-path (into root-path modal-open?-path))

(def loading?-path [:loading?])
(def loading?-full-path (into root-path loading?-path))

(def processing?-path [:processing?])
(def processing?-full-path (into root-path processing?-path))

(def error-path [:error])
(def error-full-path (into root-path error-path))

(def results-path [:results])
(def results-full-path (into root-path results-path))

(def processes-path [:processes])
(def processes-full-path (into root-path processes-path))

(def selected-lang-path [:selected-lang])
(def selected-lang-full-path (into root-path selected-lang-path))

(def subject-path [:subject])
(def subject-full-path (into root-path subject-path))
(defn subject-lang-path
  [lang]
  (into subject-full-path [lang]))

(def body-1-path [:body-1])
(def body-1-full-path (into root-path body-1-path))
(defn body-1-lang-path
  [lang]
  (into body-1-full-path [lang]))

(def body-2-path [:body-2])
(def body-2-full-path (into root-path body-2-path))
(defn body-2-lang-path
  [lang]
  (into body-2-full-path [lang]))

(defn init
  [db]
  (-> db
      (assoc-in modal-open?-full-path true)
      (assoc-in loading?-full-path true)))

(defn load-ok
  [db processes]
  (-> db
      (assoc-in loading?-full-path false)
      (assoc-in processes-full-path processes)))

(defn clean-up
  [db]
  (assoc-in db root-path nil))

(defn set-lang
  [db lang]
  (assoc-in db selected-lang-full-path lang))

(defn set-subject
  [db lang subject]
  (assoc-in db (subject-lang-path lang) subject))

(defn set-body-1
  [db lang body]
  (assoc-in db (body-1-lang-path lang) body))

(defn set-body-2
  [db lang body]
  (assoc-in db (body-2-lang-path lang) body))

(defn start-processing
  [db]
  (assoc-in db processing?-full-path true))

(defn send-failed
  [db err]
  (-> db
      (assoc-in processing?-full-path false)
      (assoc-in error-full-path err)))

(defn send-ok
  [db results]
  (-> db
      (assoc-in results-full-path results)
      (assoc-in processing?-full-path false)))
